import React from "react";

import { IconNoResults } from "../../../../assets";
import * as strings from "../../../../strings";
import Text from "../../../common/Text/Text";

const SearchBarFetching = () => {
	return (
		<div className={"SearchBarDrivers"}>
			<IconNoResults />
			<Text tag={"p"}>{strings.DRIVERS_LOADING}</Text>
			<Text tag={"p"}>{strings.MISC_PLEASE_WAIT}</Text>
		</div>
	);
};

export default SearchBarFetching;
